
const state = {
  // t添加建筑按钮的的权限 //删除维保权限
  archAdd: ['01', 'ADMIN', 'DL', '02'],
  //   单位建筑的查看按钮权限
  CheckBut: ['03', 'ADMIN', '01', '02', 'DL'],
  CheckButTwo: ['03', 'ADMIN', '01', '02', 'DL', 'YQ','ZT'],
  DelWb: ['ADMIN', 'DL'], // 删除维保计划
  Admin: ['ADMIN'],
  usersel: ['ADMIN', '01', '02', 'DL', 'YQ'],
  customer: ['03'],
  government: ['ShengZF', 'ShiZF', 'QuZF'],
  Tertiary: ['ADMIN', 'DL', 'ShengZF', 'ShiZF', 'QuZF'],
  building: ['01', 'ADMIN', 'DL','ZT'],  //单位建筑的添加
  Route: ['03', 'DL'], // 巡查路线添加
  Patrol: ['05', '02', '01'],
  maintenance: ['DL']
}

const mutations = {

}
//  在mutations 中不能定义异步函数 定时器之类的
const actions = {

}

// const module = {
//   // vuex的模块化
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions

}

